import api from './AxiosInstance';

export class PlanComptaService {
  getAllPlanCompta = async () => {
    try {
      const response = await api.get(`/PlanCompta/ChargesFG/list`, {
      /*   headers: {
          'user_id': userId 
        } */
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };


}


